module.exports = __webpack_public_path__ + "79df938b84818f0a37927aefd3b5810a.png";